var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-w-full tw-bg-brand tw-p-2 tw-my-2 tw-rounded-lg tw-text-white tw-font-thin hover:tw-bg-red-700",class:_vm.additionalClasses(),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }